<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card-group mb-0">
            <div class="card p-4">
              <b-form>
                <div class="card-body">
                  <h1>Loan Management</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <div class="input-group mb-3">
                    <span class="input-group-addon">
                      <i class="icon-user"></i>
                    </span>
                    <!-- <input type="text" class="form-control" placeholder="Username" /> -->
                    <b-form-input id="username" type="text" class="form-control" ref="username" v-model="model.username" placeholder="Username" autocomplete="username" />
                  </div>
                  <div class="input-group mb-4">
                    <span class="input-group-addon">
                      <i class="icon-lock"></i>
                    </span>
                    <!-- <input type="password" class="form-control" placeholder="Password" /> -->
                    <b-form-input id="password" type="password" class="form-control" ref="password" v-model="model.password" @keyup.13.native="login()" placeholder="Password" autocomplete="current-password" />
                  </div>
                  <b-alert :show="showinvalid" variant="danger" class="mt-4">
                    <span >Please check username and password.</span>
                  </b-alert>
                  <div class="row">
                    <div class="col-6">
                      <button type="button" class="btn btn-primary px-4" @click="login()">Login</button>
                    </div>
                    <div class="col-6 text-right">
                      <button type="button" class="btn btn-link px-0" @click="showForgotPassword=true">Forgot password?</button>
                    </div>
                    <b-modal v-model="showForgotPassword" title="Forgot Password" header-bg-variant="primary" :centered="true" hide-footer>
                      <p class="font-weight-normal mb-1">Please contact <b>Adminstrator</b> for a new password!</p>
                      <template v-slot:modal-footer>
                        <div class="w-100 mt-4">
                          <b-button
                            variant="primary"
                            size="sm"
                            class="float-right m-1"
                            @click="showForgotPassword=false"
                          >
                            Close
                          </b-button>
                        </div>
                      </template>
                    </b-modal>
                  </div>
                </div>
              </b-form>
            </div>
            <div class="card text-white py-5 d-md-down-none" style="width:44%; background-color: #ffffff">
              <div class="card-body text-center">
                <div style="margin-top: 20%;">
                  <img src="img/logo.png" height="80" alt="Logo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "../apis/auth";

export default {
  data() {
    return {
      //   model: { username: "admin", password: "admin-123" },
      model: {},
      clientDisabled: false,
      showForgotPassword: false,
      showinvalid:false
    };
  },
  created() {
    const { $route } = this;
    const { query } = $route;

    if (query && query.clientId) {
      this.model.client = query.clientId;
      this.clientDisabled = true;
    }
  },
  beforeCreate() {
    const { $router, $store } = this;
    const { user } = $store.state;
    if (user.username) {
      // const { group } = user;
    //   if (group === "admin") $router.push({ name: "admin" });
    //   if (group === "member") $router.push({ name: "app" });
        // $router.push({ name: "kredit" });
        $router.push({ name: "loan" });
    }
  },
  methods: {
    login: async function() {
      const { $router, $store } = this;
      const { username, password } = this.model;

      if (!username) return;
      if (!password) return;

      try {
        this.showinvalid=false;
        const tk = await auth.validate(this.model);
        const me = await auth.current();
        auth.save(tk, me);
        $store.commit("user", me);
        this.$socket.emit('notificationupdate', {user : me})
        // $router.push({ name: "kredit" });
        if ($store.redirectPath) {
          console.log('Login redirectPath : ',$store.redirectPath);
          $router.replace($store.redirectPath);
        }  else {
          $router.push({ name: "loan" });
        }        
      } catch (error) {
        if(error.response){
          const {status} = error.response;
          if(status==404 || status==401){
            this.showinvalid=true;
          }
        }
        console.log(error);
      }
    },
    me: async function() {
      const me = await this.$http.get("users/me");
      console.log(me);
    },
    register() {
      this.$router.push({ name: "page.register" });
    }
  }
};
</script>
